import React from 'react';
import { Link } from 'react-router-dom';
import style from './Footer.module.scss';
import logoMark from '../imgs/yesterday-stories-logo.png';
import nswLogoImg from '../imgs/nswLogo.png';
import cityCouncilImg from '../imgs/cityCouncil.png';

const Footer = () => (
    <footer className={style.footer}>
        <div className="wrap">
            <div className={style.footerTop}>
                <div>
                    <img src={logoMark} alt="Yesterday Stories" className={style.logoMark} />
                    <div className={style.footerLogo}>Yesterday Stories</div>
                    <p>
                        Copyright © 2026 Yesterday Stories PTY LTD<br />
                        <a href="mailto:info@yesterdaystories.com.au">info@yesterdaystories.com.au</a><br />
                        Made for places worth remembering
                    </p>
                </div>
                <div className={style.footerCol}>
                    <h5>Discover</h5>
                    <a href="#about">Download the app</a>
                    <a href="#stories">Featured stories</a>
                </div>
                <div className={style.footerCol}>
                    <h5>Company</h5>
                    <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                    <a href="mailto:info@yesterdaystories.com.au">Contact</a>
                    <Link to="/privacy-policy">Privacy policy</Link>
                </div>
                <div className={style.footerCol}>
                    <div className={style.sponsorLogos}>
                        <img src={nswLogoImg} alt="NSW Government" className={style.sponsorLogo} />
                        <img src={cityCouncilImg} alt="Wollongong City Council" className={style.sponsorLogo} />
                    </div>
                    <p className={style.sponsorCaption}>
                        Proudly funded by NSW Government in association with Wollongong City Council
                    </p>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
